import {
  Loading,
  Modal,
  ModalBody,
  ModalHeader,
  useToast,
} from '@teko/ds-desktop';
import { logger } from '@teko/log';
import { useTenantConfig } from 'contexts';
import { t } from 'i18n';
import { useState } from 'react';
import { subscribeToProductStockNotifications } from 'services/consumer';

interface BackInStockConfirmationModalProps {
  showBackInStockConfirmationModal: boolean;
  setShowBackInStockConfirmationModal: (value: boolean) => void;
  productName: string;
  sku: string;
}

export const BackInStockConfirmationModal: React.FC<
  BackInStockConfirmationModalProps
> = ({
  showBackInStockConfirmationModal,
  setShowBackInStockConfirmationModal,
  productName,
  sku,
}) => {
  const { tenant, terminalId, isMobile } = useTenantConfig();
  const toast = useToast();

  const [loading, setLoading] = useState(false);

  const handleSubscribeToProductStockNotifications = async () => {
    try {
      setLoading(true);
      await subscribeToProductStockNotifications({ sku, terminalId });
    } catch (error) {
      logger.error(error, 'subscribeToProductStockNotifications is failed');
      toast?.error?.({
        title: t('Lỗi'),
        message: t('Không thể lưu đăng ký lúc này. Vui lòng thử lại sau'),
      });
    } finally {
      setLoading(false);
      setShowBackInStockConfirmationModal(false);
    }
  };

  return (
    <Loading isLoading={loading}>
      <Modal
        visible={showBackInStockConfirmationModal}
        size="s"
        cancelText={t('Hủy')}
        onCancel={() => setShowBackInStockConfirmationModal(false)}
        okText={t('Đồng ý')}
        onOk={handleSubscribeToProductStockNotifications}
        showCloseIcon={false}
        fullWidthFooter={isMobile}
      >
        <ModalHeader padding="s0">
          {t('Nhận thông báo khi sản phẩm có hàng')}
        </ModalHeader>
        <ModalBody
          paddingLeft="s0"
          paddingRight="s0"
          style={isMobile ? { textAlign: 'center' } : {}}
        >
          {t(
            '{{tenant}} sẽ gửi thông báo cho bạn khi sản phẩm {{productName}} có hàng trở lại',
            {
              tenant,
              productName,
            },
          )}
        </ModalBody>
      </Modal>
    </Loading>
  );
};
